import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-gradient-to-r from-blue-400 to-indigo-600 text-white py-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-xl font-bold tracking-wider">Your Portfolio</div>
        <nav className="hidden md:flex space-x-4">
          <Link to="/" className="hover:text-gray-200 px-4">Home</Link>
          <Link to="/skills" className="hover:text-gray-200 px-4">Skills</Link>
          <Link to="/codingprofiles" className="hover:text-gray-200 px-4">Coding Profiles</Link>
          <Link to="/contact" className="hover:text-gray-200 px-4">Contact Us</Link>
        </nav>
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            <FiMenu className="text-white text-2xl" />
          </button>
        </div>
      </div>
      {isMenuOpen && (
        <nav className="md:hidden bg-indigo-600 py-2">
          <ul className="flex flex-col space-y-2">
            <Link to="/" className="hover:text-gray-200 px-4">Home</Link>
            <Link to="/skills" className="hover:text-gray-200 px-4">Skills</Link>
            <Link to="/codingprofiles" className="hover:text-gray-200 px-4">Coding Profiles</Link>
            <Link to="/contact" className="hover:text-gray-200 px-4">Contact Us</Link>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
